export function formatDateToLong(date: Date | string): string {
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }

  const dateObj = typeof date === 'string' ? new Date(date) : date

  if (isNaN(dateObj?.getTime())) {
    return ''
  }

  return new Intl.DateTimeFormat('en-US', options).format(dateObj)
}

export function formatDateTime(date: Date | string): string {
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  }
  const dateObj = typeof date === 'string' ? new Date(date) : date

  if (isNaN(dateObj?.getTime())) {
    return ''
  }

  return new Intl.DateTimeFormat('en-US', options).format(dateObj)
}

export function minutesBetweenDates(date1: Date, date2: Date): number {
  const diffMilliseconds: number = Math.abs(date1.getTime() - date2.getTime())

  const diffMinutes: number = diffMilliseconds / (1000 * 60)

  return diffMinutes
}

export function formatTimeSinceShort(date: Date, locale?: string): string {
  if (!locale) {
    const langMatch = document.cookie.match(/lang=([^;]+)/)
    locale = langMatch ? langMatch[1] : navigator.language || 'en-US'
  }

  const now = new Date()
  const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000)

  const rtf = new Intl.RelativeTimeFormat(locale, {
    numeric: 'always',
    style: 'narrow',
  })

  const secondsInMinute = 60
  const secondsInHour = 60 * secondsInMinute
  const secondsInDay = 24 * secondsInHour
  const secondsInYear = 365 * secondsInDay

  if (diffInSeconds < secondsInMinute) {
    return rtf.format(-diffInSeconds, 'second')
  } else if (diffInSeconds < secondsInHour) {
    const minutes = Math.floor(diffInSeconds / secondsInMinute)
    return rtf.format(-minutes, 'minute')
  } else if (diffInSeconds < secondsInDay) {
    const hours = Math.floor(diffInSeconds / secondsInHour)
    return rtf.format(-hours, 'hour')
  } else if (diffInSeconds < secondsInYear) {
    const days = Math.floor(diffInSeconds / secondsInDay)
    // oxlint-disable-next-line no-else-return
    return rtf.format(-days, 'day')
  } else {
    const years = Math.floor(diffInSeconds / secondsInYear)
    return rtf.format(-years, 'year')
  }
}

export function formatDateWithSeparator(
  date: Date | string,
  locale?: string,
  separator = '-',
): string {
  const dateObj = typeof date === 'string' ? new Date(date) : date

  if (isNaN(dateObj?.getTime())) {
    return ''
  }

  const day = dateObj.toLocaleDateString(locale, { day: '2-digit' })
  const month = dateObj
    .toLocaleDateString(locale, { month: 'long' })
    .replace(/^\w/, c => c.toUpperCase())
  const year = dateObj.getFullYear()

  return `${day}${separator}${month}${separator}${year}`
}

export function secondsToDate(
  timestamp: { seconds?: bigint | string | number } | null | undefined,
): Date | null {
  if (!timestamp?.seconds) {
    return null
  }
  return new Date(Number(timestamp.seconds) * 1000)
}
